import { defineComponent, openBlock, createBlock, unref, withCtx, createTextVNode } from 'vue';
import { Button } from '@ssml-editor/vue';
import { ElMessage } from 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                               */
/* empty css                                                                                                                                                 */

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "copy-menu",
  props: {
    config: {},
    editor: {}
  },
  setup(__props) {
    async function copy(code) {
      await navigator.clipboard.writeText(code);
      ElMessage.success({ message: "复制成功!", grouping: true });
    }
    function menuClickHandler() {
      if (__props.editor) {
        const codes = __props.editor.serializeAndNormalize();
        copy(codes.join(""));
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Button), {
        "icon-class": "iconfont-ssml-editor icon-ssml-editor-fuzhi",
        onClick: menuClickHandler
      }, {
        default: withCtx(() => [
          createTextVNode("复制")
        ]),
        _: 1
      });
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=copy-menu.vue.js.map
